module.exports = __webpack_public_path__ + "img/PRY.bfebabc0.svg";